/* @flow */

import * as types from 'src/shared/app/market/action/marketActionTypes';

import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  status: '',
  kind: '',
  language: '',
};

const _setStatus = (state: Object, action: Object) => {
  const { value } = action;

  return {
    ...state,
    status: value,
  };
};

const _resetStatus = (state: Object) => ({
  ...state,
  status: '',
});

const _setKind = (state: Object, action: Object) => {
  const { value } = action;

  return {
    ...state,
    kind: value,
  };
};

const _resetKind = (state: Object) => ({
  ...state,
  kind: '',
});

const _setLanguage = (state: Object, action: Object) => {
  const { value } = action;

  return {
    ...state,
    language: value,
  };
};

const _resetLanguage = (state: Object) => ({
  ...state,
  language: '',
});

const _resetFilters = (state: Object) => ({
  ...state,
  ...initialState,
});

export default createReducer(initialState, {
  [types.SET_MARKET_STATUS_FILTER]: _setStatus,
  [types.RESET_MARKET_STATUS_FILTER]: _resetStatus,
  [types.SET_MARKET_KIND_FILTER]: _setKind,
  [types.RESET_MARKET_KIND_FILTER]: _resetKind,
  [types.SET_MARKET_LANGUAGE_FILTER]: _setLanguage,
  [types.RESET_MARKET_LANGUAGE_FILTER]: _resetLanguage,
  [types.RESET_MARKET_FILTERS]: _resetFilters,
});
